import { Typography } from '@/shared/ui/Typography';
import { Download } from 'lucide-react';
import { calcFileSizeMb, getFileMeta } from '@/shared/lib/files.ts';
import { downloadableItemVariants } from './variants.ts';
import { cn } from '@/shared/styles/utils.ts';
import type { VariantProps } from 'class-variance-authority';
import type { DownloadableItemProps } from '@/features/DownloadableItem/types.ts';
import { useEffect, useState } from 'react'; // interface FileMeta {

interface FileMeta {
  size?: number;
  type?: string;
}

type Props = VariantProps<typeof downloadableItemVariants> &
  DownloadableItemProps;

export const DownloadableItem = ({ link, title, size, type }: Props) => {
  const classes = cn(downloadableItemVariants({ type }));

  const hasSize = typeof size === 'number';
  const [fileMeta, setFileMeta] = useState<FileMeta | null>(null);

  useEffect(() => {
    (async () => {
      const { size, type } = await getFileMeta(link);
      const sizeMb = calcFileSizeMb(size);
      setFileMeta({
        size: sizeMb,
        type: type.toUpperCase(),
      });
    })();
  }, []);

  return (
    <a className={classes} href={link} target="_blank" rel="noreferrer">
      <div className="overflow-hidden text-ellipsis whitespace-nowrap">
        <Typography as="h5" weight="semibold" ellipsis>
          {title}
        </Typography>
        {!hasSize && !!fileMeta && (
          <Typography type="label" color="lilac">
            {fileMeta.type}
            {' | '}
            {fileMeta.size} MB
          </Typography>
        )}
        {hasSize && (
          <Typography type="label" color="lilac">
            {calcFileSizeMb(size)} MB
          </Typography>
        )}
      </div>
      <div>
        <Download className="text-brand" />
      </div>
    </a>
  );
};
